module.exports = __webpack_public_path__ + "img/3month.a55796df.png";